module.exports = "<app-navbar></app-navbar>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main